/*
Locks

  --mount <string::enum> | ['Horizontal', 'Vertical']
  --setBack <float> | inches
  --throwDistance <float> | inches
  --materialThickness <float> | inches | default: 3/4"

*/

import { decimal } from 'vuelidate/lib/validators'
import hardwareFormFields from '@/modules/standardItems/schemas/hardware/form'

export default [
  ...hardwareFormFields,
  {
    key: 'mount',
    value: 'mount',
    type: 'radio',
    required: true,
    default: 'Horizontal',
    classes: ['xs12', 'sm8', 'input__wrapper', 'input__wrapper--centered'],
    attributes: {
      label: 'Mount',
      required: true,
      class: ['input--dense']
    },
    values: [
      {
        label: 'Horizontal',
        value: 'Horizontal'
      },
      {
        label: 'Vertical',
        value: 'Vertical'
      }
    ]
  },
  {
    key: 'setBack',
    value: 'setBack',
    type: 'float',
    classes: ['xs12', 'sm6'],
    attributes: {
      label: 'Set Back',
      suffix: 'in',
      class: ['input--dense']
    },
    validation: [
      {
        validationKey: 'decimal',
        validationFunction: decimal,
        errorMessage: 'Set Back should be a number'
      }
    ]
  },
  {
    key: 'materialThickness',
    value: 'materialThickness',
    type: 'float',
    classes: ['xs12', 'sm6'],
    attributes: {
      label: 'Material Thickness',
      suffix: 'in',
      class: ['input--dense']
    },
    validation: [
      {
        validationKey: 'decimal',
        validationFunction: decimal,
        errorMessage: 'This should be a number'
      }
    ]
  }
]
